/**
 * FoundingHat — inline gold top-hat icon rendered next to a Founding Member's
 * @username anywhere it's displayed (listings, PO cards, cart, messages,
 * public profile, etc.).
 *
 * Renders nothing when `founding` is falsy so it's safe to inline everywhere
 * without conditional wrappers.
 */
export function FoundingHat({ founding, size = 12, className = "" }) {
  if (!founding) return null;
  return (
    <span
      title="Founding Member"
      aria-label="Founding Member"
      data-testid="founding-hat"
      className={`inline-flex items-center align-middle ${className}`}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ filter: "drop-shadow(0 1px 0 rgba(0,0,0,0.6))" }}
      >
        {/* Brim */}
        <rect x="2" y="19" width="20" height="3" rx="0.5" fill="#FFD700" stroke="#8a6a00" strokeWidth="0.5" />
        {/* Top hat body */}
        <rect x="6" y="4" width="12" height="15" rx="0.5" fill="#FFD700" stroke="#8a6a00" strokeWidth="0.5" />
        {/* Band */}
        <rect x="6" y="16" width="12" height="2" fill="#8a6a00" />
      </svg>
    </span>
  );
}
